import React, { useState, useEffect } from "react";
import { Typography, Input, Button, Form, Card, message } from "antd";
import { useParams } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import { firebaseAPI } from "../firebaseConfig";
import axiosInstance from "../utils/axiosInstance";

const { Title } = Typography;

const ResetPasswordPage = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState("");

  useEffect(() => {
    // Extract token from URL
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    setToken(token);
  }, []);

  const handleSubmit = async () => {
    try {
      if (password !== confirmPassword) {
        message.error("Passwords do not match. Please try again.");
        return;
      }

      const response = await axiosInstance.post(
        `${firebaseAPI}/reset-password`,
        { token: token, password: password }
      );

      // Handle successful password reset
      if (response.status === 200) {
        message.success(
          "Password reset successful. You can now login with your new password."
        );
      } else {
        message.error("Password reset failed. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Password reset failed.Try again.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card
        style={{
          width: "500px",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={2} style={{ textAlign: "center", marginBottom: "20px" }}>
          Reset Password
        </Title>
        <Form onFinish={handleSubmit}>
          <Form.Item
            label="New Password"
            name="password"
            rules={[
              { required: true, message: "Please enter your new password" },
            ]}
          >
            <Input.Password
              placeholder="Enter your new password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
          </Form.Item>
          <Form.Item
            label="Confirm New Password"
            name="confirmpassword"
            rules={[
              { required: true, message: "Please re-enter your new password" },
            ]}
          >
            <Input.Password
              placeholder="Confirm your new password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%", borderRadius: "5px" }}
            >
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ResetPasswordPage;
